// Static data for dispensary location pages
// This file contains data that doesn't depend on any business logic

export const defaultImages = [
  '/images/catalyst-antioch-cannabis-dispensary-interior-display-cases-5851-1-scaled.webp',
  '/images/Catalyst-Cannabis-Dispensary-Store-Hours.webp',
  '/images/catalyst-antioch-cannabis-dispensary-interior-display-cases-5851-1-scaled.webp',
  '/images/Catalyst-Cannabis-Dispensary-Store-Hours.webp',
];

export const locationMeta: Record<string, { title: string; description: string }> = {
  'antioch-dispensary': {
    title:
      'Dispensary in Antioch, CA | Cleanest Cannabis Products & Best Weed Deals Near You Serving Brentwood, Oakley, Discovery Bay, Pittsburg, Bay Point',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Antioch, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'bellflower-dispensary': {
    title: 'Marijuana Dispensary in Bellflower, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Bellflower, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'belmont-shore-dispensary': {
    title: 'Marijuana Dispensary in Belmont Shore, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Belmont Shore, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'cherry-ave-long-beach-dispensary': {
    title: 'Dispensary in Long Beach, CA - Cherry Ave | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis Cherry Ave in Long Beach, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'costa-mesa-dispensary': {
    title: 'Marijuana Dispensary in Costa Mesa, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Costa Mesa, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'daly-city-dispensary': {
    title: 'Marijuana Dispensary in Daly City, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Daly City, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'downtown-long-beach-dispensary': {
    title:
      'Long Beach Dispensary | Cleanest Cannabis Products & Best Weed Deals Near You',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Downtown Long Beach, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'el-monte-dispensary': {
    title: 'Marijuana Dispensary in El Monte, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in El Monte, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'figueroa-los-angeles-dispensary': {
    title: 'Dispensary in Los Angeles, CA - Figueroa Ave | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis Figueroa Ave in Los Angeles, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'florence-los-angeles-dispensary': {
    title: 'Dispensary in Los Angeles, CA - Florence Ave | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis Florence Ave in Los Angeles, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'grover-beach-dispensary': {
    title: 'Marijuana Dispensary in Grover Beach, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Grover Beach, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'hawthorne-dispensary': {
    title: 'Cannabis Lounge & Cafe in Hawthorne, CA | Catalyst Cannabis',
    description:
      'Looking for a cannabis lounge or cafe in Hawthorne, CA? Relax, unwind, and enjoy a one-of-a-kind cannabis experience.',
  },
  'hemet-dispensary': {
    title: 'Marijuana Dispensary in Hemet, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Hemet, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'lancaster-dispensary': {
    title: 'Marijuana Dispensary in Lancaster, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Lancaster, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'lynwood-dispensary': {
    title: 'Marijuana Dispensary in Lynwood, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Lynwood, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'marina-dispensary': {
    title: 'Marijuana Dispensary in Marina, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Marina, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'mid-city-los-angeles-dispensary': {
    title: 'Dispensary in Mid City Los Angeles, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Mid City Los Angeles, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'moreno-valley-dispensary': {
    title:
      'Dispensary Moreno Valley, CA | Cleanest Cannabis Products & Best Weed Deals Near You Serving Perris, Mead Valley, Woodcrest, Riverside, Nuevo',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Moreno Valley, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'normandie-los-angeles-dispensary': {
    title: 'Dispensary in Los Angeles, CA - Normandie Ave | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis Normandie Ave in Los Angeles, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'oc3-santa-ana-dispensary': {
    title: 'Marijuana Dispensary in OC3 Santa Ana, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis OC3 in Santa Ana, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'oxnard-dispensary': {
    title:
      'Oxnard Dispensary | Cleanest Cannabis Products & Best Weed Deals Near You Serving Ventura, Camarillo, Port Hueneme, El Rio, Santa Paula',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Oxnard, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'palm-desert-dispensary': {
    title: 'Marijuana Dispensary in Palm Desert, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Palm Desert, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'patterson-dispensary': {
    title: 'Marijuana Dispensary in Patterson, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Patterson, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'pomona-dispensary': {
    title: 'Marijuana Dispensary in Pomona, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Pomona, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'planet-catalyst-orange-county': {
    title: 'Marijuana Dispensary in Santa Ana, CA | Planet Catalyst',
    description:
      'Shop the best marijuana products at Planet Catalyst in Santa Ana, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'san-bernardino-dispensary': {
    title:
      'San Bernardino Dispensary | Cleanest Cannabis Products & Best Weed Deals Near You Serving Colton, Loma Linda, Rialto, Highland, Bloomington',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in San Bernardino, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'san-diego-dispensary': {
    title:
      'San Diego Dispensary | Cleanest Cannabis Products & Best Weed Deals Near You Serving La Mesa, Lemon Grove, Santee, La Presa, Spring Valley, La Jolla',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in San Diego, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'santa-ana-dispensary': {
    title:
      'Santa Ana Dispensary | Cleanest Cannabis Products & Best Weed Deals Near You Serving Tustin, Orange, Villa Park, Yorba Linda, Placentia',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Santa Ana, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'silver-lake-dispensary': {
    title: 'Marijuana Dispensary in Silver Lake, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Silver Lake, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'stanton-dispensary': {
    title: 'Marijuana Dispensary in Stanton, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Stanton, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'van-nuys-dispensary': {
    title: 'Marijuana Dispensary in Van Nuys, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Van Nuys, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'watsonville-dispensary': {
    title: 'Marijuana Dispensary in Watsonville, CA | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis in Watsonville, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
  'retro-row-long-beach-dispensary': {
    title: 'Dispensary in Long Beach, CA - Retro Row | Catalyst Cannabis',
    description:
      'Shop the best marijuana products at Catalyst Cannabis Retro Row in Long Beach, CA. Find top-quality flower, vapes, edibles, concentrates, and more at unbeatable prices!',
  },
};

export const defaultReviewData = [
  {
    name: 'Bridget',
    rating: 5,
    date: '06/01/2025',
    title: 'Nice vibe and good people',
    review:
      'Lorem ipsum dolor sit amet consectetur. Venenatis nisi id ut est ipsum. Purus sit scelerisque arcu non. Nullam gravida interdum mollis curabitur. At condimentum nulla nunc eget vestibulum. A netus augue consectetur elementum interdum eu vehicula nunc. Montes magnis magna.',
    verified: true,
  },
  {
    name: 'Michael',
    rating: 5,
    date: '05/28/2025',
    title: 'Great selection and service',
    review:
      'Lorem ipsum dolor sit amet consectetur. Venenatis nisi id ut est ipsum. Purus sit scelerisque arcu non. Nullam gravida interdum mollis curabitur. At condimentum nulla nunc eget vestibulum. A netus augue consectetur elementum interdum eu vehicula nunc. Montes magnis magna.',
    verified: true,
  },
  {
    name: 'Sarah',
    rating: 4,
    date: '05/25/2025',
    title: 'Clean and professional',
    review:
      'Lorem ipsum dolor sit amet consectetur. Venenatis nisi id ut est ipsum. Purus sit scelerisque arcu non. Nullam gravida interdum mollis curabitur. At condimentum nulla nunc eget vestibulum. A netus augue consectetur elementum interdum eu vehicula nunc. Montes magnis magna.',
    verified: true,
  },
];

export function getDefaultFaqData(locationName: string) {
  return [
    {
      question: `Where is Catalyst ${locationName} Cannabis Dispensary located?`,
      answer: `Visit our Catalyst ${locationName} location for premium cannabis products. Check the address and map on this page for directions.`,
    },
    {
      question: 'Is there parking at the dispensary?',
      answer: 'Yes, there are dedicated parking spots available at our dispensary, along with security personnel on-site to keep your vehicle safe while you shop.',
    },
    {
      question: 'What are your store hours?',
      answer: `Check the store hours listed on this page for our ${locationName} location. Hours may vary on holidays.`,
    },
    {
      question: 'What types of payment do you accept?',
      answer: 'We accept debit cards and cash. We also have an ATM conveniently located inside the dispensary.',
    },
    {
      question: 'How much cannabis can I purchase?',
      answer: 'According to California law, you can purchase one ounce of cannabis flower (28.5 grams) and 8 grams of cannabis concentrate.',
    },
  ];
}

// Keep the old export for backwards compatibility
export const defaultFaqData = getDefaultFaqData('');
